import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const PEOPLE = [{
  name: 'María Laura',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Claudia',
  photo: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Patricia',
  photo: 'https://randomuser.me/api/portraits/women/65.jpg'
}, {
  name: 'Gabriela',
  photo: 'https://randomuser.me/api/portraits/women/50.jpg'
}, {
  name: 'Silvia',
  photo: 'https://randomuser.me/api/portraits/women/52.jpg'
}, {
  name: 'Carolina',
  photo: 'https://randomuser.me/api/portraits/women/47.jpg'
}, {
  name: 'Luciana',
  photo: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Martín',
  photo: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Diego',
  photo: 'https://randomuser.me/api/portraits/men/45.jpg'
}, {
  name: 'Fernando',
  photo: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Pablo',
  photo: 'https://randomuser.me/api/portraits/men/67.jpg'
}, {
  name: 'Alejandro',
  photo: 'https://randomuser.me/api/portraits/men/55.jpg'
}, {
  name: 'Valeria',
  photo: 'https://randomuser.me/api/portraits/women/21.jpg'
}, {
  name: 'Fernanda',
  photo: 'https://randomuser.me/api/portraits/women/75.jpg'
}, {
  name: 'Andrea',
  photo: 'https://randomuser.me/api/portraits/women/89.jpg'
}];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    photo: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const person = PEOPLE[Math.floor(Math.random() * PEOPLE.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setData({
        name: person.name,
        photo: person.photo,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(triggerPopup, 5000);
    // Subsequent popups every 15-30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        triggerPopup();
      }
    }, Math.random() * 15000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-262">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 15
    }} className="fixed bottom-3 left-3 z-40 max-w-xs w-[calc(100%-1.5rem)] md:w-auto" data-id="element-263">
          <div className="bg-white border-l-3 border-yellow-500 rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.3)] px-3 py-2.5 flex items-center gap-3" data-id="element-264">
            <img src={data.photo} alt={data.name} className="w-8 h-8 rounded-full object-cover flex-shrink-0 border border-gray-200" data-id="element-265" />
            <div className="min-w-0" data-id="element-266">
              <div className="flex items-center gap-1 flex-wrap" data-id="element-267">
                <p className="text-zinc-900 font-semibold text-xs" data-id="element-268">
                  {data.name}
                </p>
                <span className="text-zinc-500 text-[10px]" data-id="element-269">
                  de {data.city}
                </span>
              </div>
              <p className="text-zinc-600 text-xs" data-id="element-270">Compró el Sistema PRO</p>
              <div className="flex items-center gap-1 mt-0.5" data-id="element-271">
                <CheckCircle2Icon className="w-3 h-3 text-green-600" data-id="element-272" />
                <span className="text-green-600 text-[10px] font-medium" data-id="element-273">
                  Verificada
                </span>
                <span className="text-zinc-400 text-[10px] ml-0.5" data-id="element-274">
                  · Hace {data.time} min
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}